var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.512,
    height: 22.854,
    viewBox: "0 0 20.512 22.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "print",
    transform: "translate(-1044.28 -100.752)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1009",
    "data-name": "Rectangle 1009",
    width: 19.612,
    height: 5.579,
    transform: "translate(1044.73 117.578)",
    fill: "#6c5b7b",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M1060.126,113.118V101.107h-11.2v12.012",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.709
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2329",
    "data-name": "Group 2329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M1052.3,107.144l1.889,1.685,3.058-3.74",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.709
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M1048.923,110.008h-2.532a.521.521,0,0,0-.513.43l-1.163,6.526a.522.522,0,0,0,.514.614h18.591a.522.522,0,0,0,.514-.614l-1.163-6.526a.522.522,0,0,0-.514-.43h-2.531",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.709
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M1061.4,112.208l.356,2.782h-14.46l.356-2.782",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.709
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_619",
    "data-name": "Line 619",
    y2: 5.761,
    transform: "translate(1044.73 117.209)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.709
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_620",
    "data-name": "Line 620",
    y2: 5.761,
    transform: "translate(1064.342 117.209)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.709
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.71022529474538cd4b3b193f9e16487c.svg";
export { ForwardRef as ReactComponent };